import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
  name: 'money'
})
export class CurrencyPipe extends DecimalPipe implements PipeTransform {

 override transform(value: any): any {
    return '$' + super.transform(value, '1.2-2');
  }

  transformRoman(value: any, decimal: number = 2, currencySymbol: string = '$'): any {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    const absValue = Math.abs(value);
    let shortValue: string;

    if (absValue >= 1e12) {
      shortValue = (value / 1e12).toFixed(decimal) + 'T';
    } else if (absValue >= 1e9) {
      shortValue = (value / 1e9).toFixed(decimal) + 'B';
    } else if (absValue >= 1e6) {
      shortValue = (value / 1e6).toFixed(decimal) + 'M';
    } /* else if (absValue >= 1e3) {
      shortValue = (value / 1e3).toFixed(decimal) + 'K';
    } */ else {
      shortValue = value.toFixed(decimal);
    }

    // Remove unnecessary trailing zeros
    shortValue = parseFloat(shortValue).toString() + shortValue.replace(/^[0-9.-]+/, '');

    // Full value using DecimalPipe formatting
    const fullValue = super.transform(value, '1.2-2');

    // Return HTML with tooltip
    return `${currencySymbol}${shortValue}`;
  }


}
